import React from "react";
import {
  Briefcase,
  Layers,
  Database,
  MapPin,
  UserCheck,
  Workflow,
} from "lucide-react";

const strengths = [
  {
    icon: Briefcase,
    title: "17+ Years of Field Practice",
    body:
      "Boots-on-the-ground EHS work across heavy industry, construction sites and IT campuses — not theory, not templates.",
  },
  {
    icon: Layers,
    title: "Cross-Sector Depth",
    body:
      "Manufacturing, construction, warehousing, IT campus and corporate workplaces — each engagement calibrated to its operating context.",
  },
  {
    icon: UserCheck,
    title: "Lead Auditor — ISO 45001 / 14001 / 9001",
    body:
      "Certified to design, audit and defend management systems against the standards your customers and regulators expect.",
  },
  {
    icon: Database,
    title: "SAP EHS + Power BI Capability",
    body:
      "Rare combination of safety expertise and SAP S/4HANA EHS implementation experience, with Power BI dashboards that executives actually use.",
  },
  {
    icon: Workflow,
    title: "Founder-Led Delivery",
    body:
      "You work directly with Sabari — no juniors handed your audit, no sales-to-delivery handoff. Boutique attention, partner-grade rigour.",
  },
  {
    icon: MapPin,
    title: "Bengaluru-Based · Pan-India Delivery",
    body:
      "Headquartered in Bengaluru with on-site engagements across South India and structured remote advisory nationwide.",
  },
];

export default function WhyChooseUs() {
  return (
    <section
      data-testid="why-choose-us"
      id="why-choose-us"
      className="bg-bgalt border-t border-line"
    >
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10 py-20 lg:py-28">
        <div className="grid lg:grid-cols-12 gap-10 mb-14">
          <div className="lg:col-span-6">
            <p className="mono-label">Why Sabari Consultant</p>
            <h2 className="font-display text-4xl md:text-5xl lg:text-6xl uppercase tracking-tight mt-5 leading-[0.95]">
              Six reasons clients
              <br />
              keep us on retainer
              <span className="text-accent-red">.</span>
            </h2>
          </div>
          <div className="lg:col-span-5 lg:col-start-8 flex items-end">
            <p className="text-ink/70 leading-relaxed">
              Practical EHS improvements, defensible compliance posture, and
              SAP-enabled safety processes — delivered by a founder who has
              personally signed off on every audit. No outsourced delivery, no
              template proposals.
            </p>
          </div>
        </div>

        <div
          data-testid="why-grid"
          className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 border-t border-l border-line bg-white"
        >
          {strengths.map((s, i) => {
            const Icon = s.icon;
            return (
              <div
                key={i}
                data-testid={`why-card-${i}`}
                className="p-8 lg:p-10 border-r border-b border-line group hover:bg-bgdark hover:text-white transition-colors min-h-[260px]"
              >
                <div className="flex items-start justify-between mb-8">
                  <Icon
                    size={26}
                    strokeWidth={1.4}
                    className="text-accent-red group-hover:text-accent-amber transition-colors"
                  />
                  <span className="font-mono text-[11px] text-ink-muted group-hover:text-white/50">
                    0{i + 1}
                  </span>
                </div>
                <h3 className="font-display text-xl uppercase tracking-tight leading-tight">
                  {s.title}
                </h3>
                <p className="mt-3 text-sm leading-relaxed text-ink/70 group-hover:text-white/75">
                  {s.body}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
